import React, { PropsWithChildren } from "react";

const AppContent = ({ children }: PropsWithChildren) => {
  return <>{children}</>;
};

const LoginGate = ({ children }: PropsWithChildren) => {
  return <AppContent>{children}</AppContent>;
};

export default LoginGate;
